import React, { useCallback, useEffect, useState } from 'react';
import { CardContent, FlexWrapper } from '../../theme/common_style';
import ActivityDrawer from './ActivityDrawer';
import { Drawer } from 'antd';
import { ClientCardIcon1, ClientCardIcon2, ClientCardIcon3 } from '../../theme/SvgIcons';
import Title from 'antd/es/typography/Title';
import ProjectCard from '../../components/projects/ProjectCard';
import ClientDetails from './ClientDetails';
import { toast } from 'react-toastify';
import { getAllClients, getClientCountsApi } from '../../services/api_collection';
import { debounce } from '../../utils/common_functions';
import { useDispatch, useSelector } from 'react-redux';
import { updateActivityDrawer } from '../../redux/sidebar/SidebarSlice';
import CountUp from 'react-countup';
import styled from '@emotion/styled';

const ClientRoot = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [search, setSearch] = useState(null);
  const [clientCounts, setClientCounts] = useState(null);
  const [cardsLoading, setCardsLoading] = useState(false);
  const activityDrawer = useSelector((state) => state?.sidebar?.isActivityDrawer);
  const { user_details } = useSelector((state) => state?.userInfo?.data || {});
  const dispatch = useDispatch();

  const [status, setStatus] = useState(null);
  const [sort, setSort] = useState({});

  const attendanceStats = [
    {
      icon: <ClientCardIcon1 />,
      bg: '#DDF3FF',
      label: 'Total Clients',
      value: clientCounts?.totalClients || 0
    },
    {
      icon: <ClientCardIcon2 />,
      bg: '#FFE8A8',
      label: 'Active Clients',
      value: clientCounts?.activeClients || 0
    },
    {
      icon: <ClientCardIcon3 />,
      bg: '#D9D6FF',
      label: 'Active Projects',
      value: clientCounts?.activeProjects || 0
    }
  ];

  const getClientsCount = async () => {
    try {
      setCardsLoading(true);
      const res = await getClientCountsApi();
      if (res?.statusCode === 200) {
        setClientCounts(res?.data);
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error?.message || 'Something went wrong');
    } finally {
      setCardsLoading(false);
    }
  };

  const handleGetList = async (search) => {
    try {
      setLoading(true);
      let params = new URLSearchParams();
      params.append('limit', limit);
      params.append('page', page);
      search && params.append('search', search);
      if (sort?.sortBy && sort?.orderBy) {
        params.append('sort_field', sort?.sortBy);
        params.append('sort_order', sort?.orderBy);
      }
      if (status != null || status != undefined) {
        params.append('client_status', status);
      }
      const res = await getAllClients(params);
      if (res?.statusCode === 200) {
        let array = (res?.data?.clients || [])?.map((el, idx) => ({
          ...el,
          key: idx + 1
        }));
        setData(array || []);
        setTotal(res?.data?.total_count);
      } else toast.error(res?.message || 'Something went wrong');
    } catch (err) {
      toast.error(err?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const optimizedFn = useCallback(debounce(handleGetList), [page, limit, status, sort]);

  useEffect(() => {
    if (search !== null) {
      optimizedFn(search);
    } else {
      handleGetList();
    }
  }, [search, page, limit, status, sort]);

  useEffect(() => {
    getClientsCount();
  }, []);
  return (
    <FlexWrapper direction="column" gap="20px" cursor="default">
      {activityDrawer && (
        <Drawer
          width={490}
          title="Activity"
          placement="right"
          closable={true}
          prefixCls="activityCustomDrawer"
          onClose={() => dispatch(updateActivityDrawer(false))}
          open={activityDrawer}
          key="right">
          <ActivityDrawer clientId={user_details?.id} />
        </Drawer>
      )}
      <FlexWrapper
        width="100%"
        direction="column"
        cursor="default"
        gap="5px"
        justify="space-between"
        align="space-between">
        <FlexWrapperCard>
          {attendanceStats.map((item, index) => (
            <ProjectCard
              key={index}
              image={item.icon}
              bg={item.bg}
              loading={cardsLoading}
              content={
                <>
                  <CardContent>{item.label}</CardContent>
                  <Title style={{ margin: 0 }} level={2}>
                    <CountUp end={(item.value || 0)?.toString()?.padStart(2, '0')} />
                  </Title>
                </>
              }
            />
          ))}
        </FlexWrapperCard>
      </FlexWrapper>

      <ClientDetails
        loading={loading}
        data={data}
        page={page}
        limit={limit}
        total={total}
        setPage={setPage}
        setLimit={setLimit}
        setSearch={setSearch}
        handleGetList={handleGetList}
        setStatus={setStatus}
        search={search}
        sort={sort}
        setSort={setSort}
      />
    </FlexWrapper>
  );
};

export default ClientRoot;
export const FlexWrapperCard = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ cols }) => `repeat(${cols || 3}, 1fr)`};
  gap: ${(props) => props.gap || '10px'};
  justify-items: ${(props) => props.justify || 'center'};
  align-items: ${(props) => props.align || 'center'};

  @media (max-width: 924px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 5px;
  }
`;
